<template>
  <div id="app" v-if="appShow">
    <router-view/>
  </div>
</template>
<script>
	export default {
    data() {
      return {
        appShow: false,
      };
    },
    created() {
      this.getInfo();
    },
  methods: {
    async getInfo() {
      const token = this.$mUtils.getUrlParam({ url: location.href, key: 'token'})
      if(token){
        this.$store.commit('UPDATE_ACCESS_TOKEN', token)
        const { user } = await this.$axios.get('/sys/user/info');
        this.$store.commit('UPDATE_USER_INFO', {
          _id: user.userId.id,
          name: user.userName.name,
          username: user.userName.name,
          avatar: user.headImage,
          mobile: user.mobile,
        })
        this.appShow = true;
        history.pushState({}, '', this.$mUtils.removeURLParameter(location.href, 'token'));
      }else{
        this.appShow = true;
      }
    },
  },
	}
</script>
<style lang="scss">
html,body{
  position: relative;
  height: 100%;
}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  position: relative;
  height: 100%;
  overflow: hidden;
}

</style>
